import styled from "@emotion/styled"
import { PTag, PText } from "@porsche-design-system/components-react"
import { colorError, colorSuccess } from "@porsche-design-system/components-react/emotion"
import type { VehicleOrderView } from "@slfinrtl/ui-bff-routes"
import { ColorIndicator } from "src/common/ColorIndicator"
import { Flex } from "src/components"

interface VehicleOrderStatusProps {
	view: VehicleOrderView
}

export const VehicleOrderStatus = ({ view }: VehicleOrderStatusProps) => {
	const errorMessage = view.errorMessage ? `${view.errorMessage} (${view.errorCode})` : view.errorCode

	return (
		<Flex $gap="xs" $direction="column">
			<Flex $gap="xs" $alignItems="center">
				<ColorIndicator $color={view.errorCode ? colorError : colorSuccess} $size={8} />
				<PTag compact>{view.statusCode}</PTag>
				<StatusMessage title={view.statusMessage} ellipsis>
					{view.statusMessage}
				</StatusMessage>
			</Flex>
			{view.errorCode && (
				<ErrorMessageTag variant="error-frosted" icon="error" title={errorMessage}>
					<ErrorMessageText title={errorMessage} size="xs" ellipsis>
						{errorMessage}
					</ErrorMessageText>
				</ErrorMessageTag>
			)}
		</Flex>
	)
}

const StatusMessage = styled(PText)`
	min-width: 0;
	flex: 1;
`

const ErrorMessageTag = styled(PTag)`
	display: inline-block;
	align-self: flex-start;
	min-width: 0;
	max-width: 100%;
`

const ErrorMessageText = styled(PText)`
	display: inline-block;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`
